import React, { useState, useRef } from 'react'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import styled from 'styled-components'   
import { useSelector, useDispatch } from 'react-redux'
import Tooltip from '@mui/material/Tooltip';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'; 
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'; 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'
import { ButttonWrap } from 'components/files/files.styled'
import { SubmitButton } from 'components/giving/giving.styled'  
import SpinnerSmall from 'components/SpinnerSmall'
import { createCalendarItem } from 'features/events/eventSlice'
import { VscChromeClose } from "react-icons/vsc";     
import { PrayselyColorPicker } from 'components/PrayselyColorPicker';
import useToggleDropdown from 'hooks/useToggleDropdown';
import { useTranslation } from 'react-i18next'

const dateInputStyle = {
    borderColor: "white",
    width: "100%",
    input: { color: '#868686' },
    "& .MuiInputLabel-root.Mui-focused": { 
      color: "#656565" 
    }, //styles the label
    "& .MuiOutlinedInput-root": {
     "&:hover > fieldset": { borderColor: "white" },
     height: "48px",
     borderRadius: "10px",
     backgroundColor: 'aliceblue',
     borderColor: "white"
    },
    ".MuiOutlinedInput-notchedOutline":{
      border: "none",
    }
  }

const timeInputStyle = {
    borderColor: "white",
    width: "200px",
    input: { color: '#868686' },
    "& .MuiInputLabel-root.Mui-focused": { 
      color: "#656565" 
    }, //styles the label
    "& .MuiOutlinedInput-root": {
     "&:hover > fieldset": { borderColor: "white" },
     height: "48px",
     borderRadius: "10px",
     backgroundColor: 'aliceblue',
     borderColor: "white"
    },
    ".MuiOutlinedInput-notchedOutline":{
      border: "none",
    }
}
 

const hexColors = [ '#FF6B6B', '#FF8E53', '#4a600d',  '#7B68EE' ]
 

export default function CreateCalendarItem() {
    const { t } = useTranslation(['events', 'common'])
    const dispatch = useDispatch()
    const eventNameRef = useRef(null)
    const { createCalendarItemStatus } = useSelector((state) => state.events)
    const [selectedDates, setSelectedDates] = useState([])
    const [selectedTimes, setSelectedTimes] = useState([])
    const [openStartTime, setOpenStartTime] = useState(false)
    const [openEndTime, setOpenEndTime] = useState(false)
    const [openStart, setOpenStart] = useState(false)
    const [startDate, setStartDate] = useState(dayjs( `${dayjs().year()}-${dayjs().month() + 1}-${dayjs().date()}`));
    const [startTime, setStartTime] = useState( dayjs( `2024-01-17T15:30`));
    const [endTime, setEndTime] = useState( dayjs( `2024-01-17T16:30`));
    const [selectedColor, setSelectedColor] = useState(hexColors[2]);
    const colorPickerRef = useRef(null)
    const [isDropped, setIsDropped] = useToggleDropdown(colorPickerRef)
    const handleDropDown = () => { setIsDropped.toggle(colorPickerRef) }
 
    const handleDate = (date) => {
        let dateString = date.toString().split(' ')
        let dateStr = `${dateString[1]} ${dateString[2]} ${dateString[3]}` 
        setSelectedDates([...selectedDates, dateStr]) 
    }

    const removeDateFromList = (date) => {
        let newDates = selectedDates.filter(d => d !== date)
        setSelectedDates(newDates)
    }

    const handleTime = (time) => {
        setSelectedTimes({
            ...selectedTimes,
            time
        })
    }

    const handleSetColor = (value) => {
        setSelectedColor(hexColors[value])
    }

    const handleSubmit = () => { 
        let startTime0 = `${startTime.get('hour')}:${startTime.get('minute')}`
        let endTime0 = `${endTime.get('hour')}:${endTime.get('minute')}`
        let uniqueDates = [...new Set(selectedDates)] 
        dispatch(createCalendarItem({
            eventName: eventNameRef.current.value,
            startTime: startTime0,
            endTime: endTime0,
            selectedDates: JSON.stringify(uniqueDates), 
            color: selectedColor
        })) 
    }

    return (
        <CreateCalendarItemForm>
            <TopBar><h2>{t('events:calendar.create')}</h2></TopBar>

            <EventNameInput 
                ref={eventNameRef}
                placeholder={t('events:create.eventName')}
                 /> 

                <SlctCont> 
                    <BxItemCont>
                        <h2>{t(selectedDates.length > 0 ? 'events:calendar.selectMore' : 'events:calendar.selectDates')}</h2>
                        <LocalizationProvider dateAdapter={AdapterDayjs}> 
                        <DesktopDatePicker
                            value={startDate}
                            onChange={handleDate}
                            sx={dateInputStyle}
                            open={openStart}
                            onClose={() => setOpenStart(false)}
                            slotProps={{textField: {onClick: () => setOpenStart(true)},}} 
                            />
                        </LocalizationProvider>
                    </BxItemCont>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                        <BxItemCont2>
                            <h2>{t('events:calendar.selectStart')}</h2>
                            <LocalizationProvider dateAdapter={AdapterDayjs}> 
                            <DesktopTimePicker
                                value={startTime}
                                onChange={(newValue) => setStartTime(newValue)}
                                sx={timeInputStyle}
                                defaultValue={dayjs('2022-04-17T15:30')} 
                                open={openStartTime}
                                onClose={() => setOpenStartTime(false)}
                                slotProps={{textField: {onClick: () => setOpenStartTime(true)},}}
                                />
                            </LocalizationProvider>   
                        </BxItemCont2>
                        <BxItemCont2>
                            <h2>{t('events:calendar.selectEnd')}</h2>
                            <LocalizationProvider dateAdapter={AdapterDayjs}> 
                            <DesktopTimePicker
                                value={endTime}
                                onChange={(newValue) => setEndTime(newValue)}
                                sx={timeInputStyle}
                                defaultValue={dayjs('2022-04-17T15:30')}
                                open={openEndTime}
                                onClose={() => setOpenEndTime(false)}
                                slotProps={{textField: {onClick: () => setOpenEndTime(true)},}}
                                />
                            </LocalizationProvider>   
                        </BxItemCont2>
                    </div>
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            marginTop: '20px'
                        }}> 
                        <DatesCont>
                            <h2>{t('events:calendar.selectedDates')}</h2>

                            <BxItemW style={{width: 'fit-content'}}>
                            { 
                                selectedDates.map((date, index) => (
                                    <DateBxItem key={date}>
                                        <h2>{date}</h2>
                                        <div onClick={() => removeDateFromList(date)}>
                                            <Tooltip title={t('events:calendar.removeDate')}>
                                                <VscChromeClose style={{fontSize: '15px', cursor: 'pointer'}} />
                                            </Tooltip>
                                        </div> 
                                    </DateBxItem>
                                ))
                            }
                            </BxItemW> 
                        </DatesCont>
                    </div>
                </SlctCont>  
                <div style={{ width: '100%', marginTop: 'auto', flexDirection: "column" }} >
                <h2 style={{fontSize: "13px"}}>{t('events:calendar.selectColor')}</h2>
                <ButttonWrap style={{ justifyContent: "space-between", marginTop: '0px', marginBottom: '0px' }} > 
                    <ColorPickerDiv ref={colorPickerRef}  >
                    
                            {
                                hexColors.map((item, index) => ( 
                                    <CircleBorder 
                                        onClick={() => handleSetColor(index)}
                                        selected={item === selectedColor}
                                        >
                                        <ColorCircle backgroundColor={item} > 
                                        </ColorCircle>  
                                    </CircleBorder>   
                                ))
                            } 
                            <Tooltip placement='top' title={t('events:calendar.customColor')}>
                                <CircleBorder selected={
                                    (!hexColors.includes(selectedColor))
                                } > 
                                {
                                    !hexColors.includes(selectedColor) ? 
                                    (
                                        <ColorCircle backgroundColor={selectedColor} > 
                                        </ColorCircle>  
                                    )
                                    :
                                    (
                                        <Checker onClick={handleDropDown}> 
                                        </Checker>
                                    )
                                }

                                </CircleBorder> 
                            </Tooltip>
                            {
                                isDropped && (
                                    <ColorPickerWrapper>
                                        <PrayselyColorPicker
                                            onThemeApply={setSelectedColor}
                                            initialColor={selectedColor}
                                            onSelectClick={() => handleDropDown()}
                                            />
                                    </ColorPickerWrapper>
                                )
                            }
                    </ColorPickerDiv>

                    <SubmitButton 
                        // disabled={createCalendarItemStatus === "LOADING" ? true : false} 
                        onClick={handleSubmit}> 
                            {
                                createCalendarItemStatus === "LOADING" ? <SpinnerSmall /> : t('events:calendar.createAction')
                            } 
                    </SubmitButton>  
                </ButttonWrap> 
            </div>

        </CreateCalendarItemForm>
    )
}

const ColorPickerWrapper = styled.div` 
    position: absolute;
    top: 0;
    right: 0;
    margin-top: -270px;
    width: 265px;
    margin-left: -420px;
`

const Checker = styled.div`
  width: 35px;
  height: 35px;
  background-color: #fff;
  background-image:
    linear-gradient(45deg, #cccccc 25%, transparent 25%),
    linear-gradient(-45deg, #cccccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #cccccc 75%),
    linear-gradient(-45deg, transparent 75%, #cccccc 75%);
  background-size: 10px 10px; /* 5px black + 5px white */
  background-position: 0 0, 0 5px, 5px -5px, -5px 0;
  border-radius: 50%;
`;

const CircleBorder = styled.div` 
    display: flex;
    align-items: center;
    justify-content: center;
    height: fit-content;
    width: fit-content;
    padding: 3px;
    border-radius: 50%;
    border: 3px solid ${props => props.selected ? "#ccc":"transparent"};

`

const ColorCircle = styled.div`
    background-color: ${props => props.backgroundColor};
    width: 35px;
    height: 35px;
    border-radius: 50%; 
`

const ColorPickerDiv = styled.div` 
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
    gap: 4px;
    position: relative;
`


const DatesCont = styled.div`

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 20px;  
    h3{
        font-size: 12px;
    } 
`


const BxItemW = styled.div`
    width: 100%;
    display: flex;
    height: 130px;
    background-color: aliceblue; 
    padding: 10px;
    flex-direction: row;
    flex-wrap: wrap; 
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 10px;
    overflow-y: scroll;
`


const BxItemCont = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px; 
`

const BxItemCont2 = styled.div`
    width: fit-content  ;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px; 
`

const DateBxItem = styled.div`
    width: 150px; 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    height: fit-content;
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    margin-right: 10px;
    margin-bottom: 5px;

    svg{
        margin-left: 10px;
        cursor: pointer;
        color: red;
    }
    
`

const SlctCont = styled.div`
    width: 100%;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 15px; 
    &::-webkit-scrollbar {
        display: none;
    }
    h2{ 
        font-size: 12px;
    }
`

const TopBar = styled.div`
    width: 100%;
    height: fit-content;
    display: flex; 
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    h2{
        font-size: 20px;
        color: var(--lightThemeFontColor);
        font-weight: 500;
        margin-bottom: 20px;
    }

`

const EventNameInput = styled.input`
    width: 100%;
    height: 40px;
    margin-top: 10px;
    padding: 10px;
    border: 1px solid transparent;
    border-radius: 5px;
    outline: none;
    font-size: 15px;
    color: var(--lightThemeFontColor);
    background-color: aliceblue;
    transition: 0.3s;
    &:focus{
        border: 1px solid var(--themeColor);
    }
`


const CreateCalendarItemForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 600px;
    height: 600px;
    overflow-y: hidden;
    background-color: white;
    border-radius: 10px; 
    padding: 20px;
    color: var(--lightThemeFontColor);

    @media (max-width: 600px){
        width: 100%;
    }
 
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
 `
